import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { IBalance } from '@/shared/interfaces/balance.interface'

const balanceDefault = (): IBalance => {
  return {
    mainBalance: 0,
    mainBalanceExp: '',
    promotionalBalance: 0,
    promotionalBalanceExp: '',
    bonusBalance: 0,
    bonusBalanceExp: '',
    totalCredit: 0,
    consumedCredit: 0,
    creditExp: ''
  } as IBalance
}

export const useBalanceStore = defineStore('balance', () => {
  const balance = ref<IBalance>(balanceDefault())
  const balanceConsulted = ref<boolean>(false)

  const setBalance = (_balance: IBalance) => {
    balance.value = _balance
  }

  const setBalanceConsulted = (_balanceConsulted: boolean) => {
    balanceConsulted.value = _balanceConsulted
  }

  return {
    balance,
    balanceConsulted,
    setBalance,
    setBalanceConsulted
  }
})
